"use client";

import type { PropsWithChildren } from "react";

import { m } from "motion/react";

import { createStyle } from "~/common/utils/create-style";
import { ChatLayoutRoot } from "~/chat/components/chat.layout";
import { useWorkspace } from "~/workspaces/hooks/use-workspace";
import { NavigationTop } from "~/common/components/navigation-top";
import { NavigationLeft } from "~/common/components/navigation-left";
import { NavigationRight } from "~/common/components/navigation-right";
import { useDataSources } from "~/data-sources/queries/get-data-sources-query";
import { DataSourcesDialog } from "~/data-sources/components/data-source-dialog";
import { getIsDataSourceOnboarded } from "~/data-sources/utils/data-source-onboarding";

// TODO: temporary solution, this should be done differently
function WorkspaceClientLayout({ children }: PropsWithChildren) {
  const { selectedWorkspace } = useWorkspace();

  const { data: shouldOnboard, isLoading } = useDataSources(
    { workspaceId: selectedWorkspace.id },
    (dataSources) =>
      getIsDataSourceOnboarded(selectedWorkspace.id, dataSources),
  );

  if (isLoading) {
    return null;
  }

  return (
    <m.div className={style.container()}>
      {!!shouldOnboard && <DataSourcesDialog />}

      {!shouldOnboard && (
        <>
          <NavigationTop className={style.topBar()} />
          <NavigationLeft className={style.sideNav({ side: "left" })} />

          <ChatLayoutRoot
            role="main"
            className="relative"
          >
            {children}
          </ChatLayoutRoot>

          <NavigationRight className={style.sideNav({ side: "right" })} />
        </>
      )}
    </m.div>
  );
}

const style = createStyle({
  slots: {
    container: "h-screen grid grid-cols-1 lg:grid-cols-[26rem_1fr_26rem]",
    sideNav: [
      "bg-overlay-on-dark-10 border-border-on-dark-opacity-01",
      "hidden lg:flex overflow-y-auto",
    ],
    topBar: "flex w-full lg:hidden h-[6.8rem]",
  },
  variants: {
    side: {
      left: { sideNav: "border-r" },
      right: { sideNav: "border-l" },
    },
  },
})();

export { WorkspaceClientLayout };
